import gql from 'graphql-tag';
import { Good360FullFragment } from '../fragments/Good360FullFragment';

export const Good360CreateMutation = gql`
	mutation Good360CreateMutation($values: Good360CreateInput!) {
		results: good360Create(values: $values) {
			...Good360FullFragment
		}
	}
	${Good360FullFragment}
`;